<div class="card">
  <h6 class="card-header">
    <ng-content select="[psCardHeader]"></ng-content>
  </h6>
  <div class="card-content">
    <ng-content select="[psCardContent]"></ng-content>
  </div>
  <div class="card-footer">
    <ng-content select="[psCardFooter]"></ng-content>
  </div>
</div>
